import { makeStyles, createStyles } from '@material-ui/core/styles';

const PrivateMessageSectionStyles = makeStyles((theme: any) => createStyles({
  privateMessageText: {
    fontSize: 14,
    position: "relative",
    textAlign: "left",
    left: 11,
    marginBottom: 10,
  },
  closeIconButton: {
    position: "absolute",
    padding: 3,
    right: 5,
    top: 5,
  },
  arrowUpIcon: {
    fontSize: 30,
  },
  messageIcon: {
    position: "relative",
    left: 11,
    marginBottom: 8,
  }
})
)

export { PrivateMessageSectionStyles }; 